'use strict';

module.exports = function(ngModule) {
  console.log('Create Alert directive');
  ngModule.directive('customAlerts', ['Alert', function (Alert)  {
    return {
      scope: {
        alertType: '@?',
        report: '@?',
      },
      template: require('./alert.html'),
      restrict: 'EA',
      link: function (scope, element, attrs) {
        scope.alertSrvs=Alert;
      }
    };
 }]);
};
